<template>
  <div class="page-content personal-info">
    <div class="page-tit tit">
      <div class="item clr-b">个人信息</div>
      <div class="arrow">
        <svg viewBox="0 0 1035 1024" width="16" height="16">
          <path
            d="M530.850448 573.163313c32.005172-31.883636 32.111192-87.434343-0.069818-119.489939C399.437114 322.845737 268.507336 191.603071 137.436629 60.506505c-12.621576-12.625455-27.585939-20.686869-45.26804-23.540364-3.529697-0.570182-7.085253-0.999434-10.630465-1.499798-1.025293 0-2.055758 0-3.081051 0-4.035232 0.575354-8.111838 0.943838-12.091475 1.757091-33.298101 6.818909-54.838303 26.616242-63.959919 59.278222-3.201293 11.479919-2.806949 24.85398-1.135192 35.701657 1.751919 11.344162 7.11499 21.818182 14.479515 30.904889 3.444364 4.252444 7.050343 8.418263 10.918788 12.291879 111.045818 111.127273 222.142061 222.222222 333.247354 333.293899 1.444202 1.444202 3.227152 2.554828 5.187232 4.080485-2.121697 2.222545-3.475394 3.696485-4.879515 5.100606C252.653437 625.450667 145.164468 733.112889 37.416912 840.506182c-15.829333 15.773737-33.541172 31.162182-36.146424 54.273293-1.233455 10.908444-1.859232 22.111677 0 32.929616 0.919273 5.363071 3.262061 10.423596 5.494949 15.358707 23.655434 52.318384 89.514667 64.241778 130.66602 23.186101C268.668953 835.315071 399.501761 703.987071 530.850448 573.163313L530.850448 573.163313zM78.451902 35.466343l-12.091475 1.757091C70.345235 36.410182 74.421841 36.041697 78.451902 35.466343L78.451902 35.466343zM551.467498 36.441212c-38.000485 2.858667-70.434909 37.034667-71.651556 75.106263-0.79903 24.979394 8.131232 45.650747 25.691798 63.197091 111.383273 111.252687 222.661818 222.615273 334.015354 333.893818 1.534707 1.534707 3.686141 2.448808 6.595232 4.327434-3.35903 2.667313-5.116121 3.803798-6.565495 5.253172-68.050747 68.000323-136.075636 136.035556-204.100525 204.065616C591.916791 765.814949 548.391619 809.360808 504.845761 852.880808c-19.449535 19.439192-28.328081 42.706747-24.045899 70.054788 4.829091 30.919111 22.440081 52.516202 51.712 63.010909 29.450343 10.550303 56.692364 4.803232 80.49002-15.848727 1.944566-1.682101 3.798626-3.470222 5.616485-5.288081 130.121697-130.111354 259.955071-260.509737 390.546101-390.141414 33.272242-33.035636 33.454545-88.934141 1.206303-121.050505C879.016912 322.804364 748.093599 191.557818 617.028064 60.456081c-12.626747-12.626747-27.611798-20.655838-45.288727-23.505455-3.534869-0.570182-7.090424-0.994263-10.635636-1.484283-1.030465 0-2.055758 0-3.086222 0.005172C555.835013 35.799919 553.659013 36.274424 551.467498 36.441212L551.467498 36.441212zM551.467498 36.441212"
            fill="#666"
          ></path>
        </svg>
      </div>
      <div class="item">工作信息</div>
    </div>
    <div class="page-form content">
      <Form
        :ref="`form-personal`"
        :defaultForm.sync="form"
        :fields="fields"
        :defaultText.sync="fieldTexts"
      >
        <van-field
          slot="field-custom-spouseName"
          v-model.trim="form.spouseName"
          label="配偶姓名"
          placeholder="上传识别或输入"
          :rules="required"
          required
          input-align="right"
          @change="setContacts1Name"
        >
          <template #right-icon>
            <ImgIcon :size="28" color="#4191f9" @click="openIdcarOcr" />
          </template>
        </van-field>
      </Form>
      <Form
        formShowTitle="联系人1"
        :ref="`form-contacts1`"
        :defaultForm.sync="contacts1Form"
        :fields="contacts1Fields"
        :disabled="isMarried"
        :defaultText.sync="contacts1Text"
      />
      <Form
        formShowTitle="联系人2"
        :ref="`form-contacts2`"
        :defaultForm.sync="contacts2Form"
        :fields="contacts2Fields"
        :defaultText.sync="contacts2Text"
      />
    </div>

    <div class="page-btn btns">
      <van-button type="info" size="small" @click="nextFn">下一步</van-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { uploadFile } from "@/api/upload";
import { ocrIdentify, createPersonalInfo, getPersonalInfo } from "@/api/apply";
import { getSomeEnums } from "@/api/enums";
import { setFormData } from "../dev_form_json";
import { isImage, isJPG, imageToJPG } from "@/utils/upload-tool.js";

export default {
  components: {
    Form: () => import("@/components/Form/Index"),
    ImgIcon: () => import("@/components/ImgIcon.vue")
  },
  data() {
    return {
      required: [
        {
          required: true
        }
      ],
      bizNo: "",
      enums: {},
      form: {},
      ocrShow: false,
      fieldTexts: {},
      contacts1Form: {},
      contacts1Text: {},
      contacts2Form: {},
      contacts2Text: {}
    };
  },
  computed: {
    isMarried() {
      const arr = ["20", "50", "60", "70"];
      return arr.includes(this.form?.maritalStatus);
    },
    fields() {
      const pre = [
        {
          type: "select",
          label: "学历",
          required: true,
          key: "educationType",
          enums: this.enums?.education || []
        },
        {
          type: "select",
          label: "学位",
          required: true,
          key: "academicDegreeType",
          enums: this.enums?.educationDegree || []
        },
        {
          type: "text",
          label: "微信号",
          required: true,
          key: "wechatNo"
        },
        {
          type: "text",
          label: "电子邮箱",
          required: true,
          key: "email",
          validator: (v) => {
            const reg =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (v && !reg.test(v)) throw "请输入正确的电子邮箱";
            else return true;
          }
        },
        {
          type: "select",
          label: "是否金融首贷",
          labelWidth: "7.2em",
          required: true,
          key: "firstLoanType",
          enums: [
            {
              text: "是",
              value: "Y"
            },
            {
              text: "否",
              value: "N"
            }
          ]
        },
        {
          type: "select",
          label: "婚姻",
          required: true,
          key: "maritalStatus",
          enums: this.enums?.maritalStatus || [],
          change: () => {
            if (!this.isMarried) {
              const emptyKeys = [
                "spouseName",
                "spouseCertNo",
                "spousePhone",
                "workUnit"
              ];
              emptyKeys.map((k) => {
                this.$set(this.form, k, "");
              });
              this.$set(this.contacts1Form, "contactRelation", "");
            } else {
              this.$set(this.contacts1Form, "contactRelation", "1");
            }
          }
        }
      ];
      const married = [
        {
          type: "custom",
          label: "配偶姓名",
          required: true,
          placeholder: "上传识别",
          key: "spouseName",
          validator: (v) => {
            const reg = /^(?:[\u4e00-\u9fa5·]{2,20})$/;
            if (v && !reg.test(v)) throw "请输入正确的姓名";
            else return true;
          },
          change: (v) => {
            this.$set(this.contacts1Form, "contactName", v);
          }
        },
        {
          type: "text",
          label: "配偶身份证号",
          required: true,
          placeholder: "上传识别或输入",
          // disabled: true,
          key: "spouseCertNo",
          validator: (v) => {
            const reg =
              /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/;
            if (v && !reg.test(v)) throw "请输入正确的身份证号";
            else return true;
          }
        },
        {
          type: "number",
          label: "配偶手机号",
          required: true,
          key: "spousePhone",
          validator: (v) => {
            const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if (v && !reg.test(v)) throw "请输入正确的手机号";
            else return true;
          },
          change: (v) => {
            this.$set(this.contacts1Form, "contactPhone", v);
          }
        },
        {
          type: "text",
          label: "配偶单位",
          required: true,
          key: "workUnit"
        }
      ];
      const suff = [
        // {
        //   type: "select",
        //   label: "居住状况",
        //   required: true,
        //   key: "addrType",
        //   enums: this.enums?.resideStatus || []
        // },
        {
          type: "select",
          label: "居住状况",
          required: true,
          key: "resideType",
          enums: this.enums?.resideStatus || []
        },
        {
          type: "select",
          label: "居住年限",
          required: true,
          key: "localResideYears",
          enums: this.enums?.resideYears || []
        },
        {
          type: "region",
          label: "居住地址",
          required: true,
          key: "pcrcode",
          keys: ["provinceCode", "cityCode", "regionCode"],
          namesKey: ["provinceName", "cityName", "regionName"]
        },
        {
          type: "textarea",
          label: "详细地址",
          required: true,
          key: "resideAddress"
        }
      ];
      let def = [...pre];
      if (this.isMarried) {
        def.push(...married);
      }
      def.push(...suff);
      return def;
    },
    contacts1Fields() {
      return [
        {
          type: "text",
          label: "联系人姓名",
          required: true,
          key: "contactName",
          validator: (v, pre) => {
            const reg = /^(?:[\u4e00-\u9fa5·]{2,20})$/;
            if (v && !reg.test(v)) throw pre + "请输入正确的姓名";
            else return true;
          }
        },
        {
          type: "number",
          label: "联系人电话",
          required: true,
          key: "contactPhone",
          blur: () => {
            const contactPhone1 = this.contacts1Form.contactPhone;
            const contactPhone2 = this.contacts2Form.contactPhone;
            if (contactPhone1 == contactPhone2) {
              this.$errMsg("联系人2与联系人1电话号码不能相同！");
            } else {
              this.$toast.clear();
            }
          },
          validator: (v, pre) => {
            const contactPhone1 = this.contacts1Form.contactPhone;
            const contactPhone2 = this.contacts2Form.contactPhone;
            const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if (contactPhone1 == contactPhone2)
              throw "联系人2与联系人1电话号码不能相同！";
            else if (v && !reg.test(v)) throw pre + "请输入正确的手机号";
            else return true;
          }
        },
        {
          type: "select",
          label: "联系人关系",
          required: true,
          key: "contactRelation",
          enums:
            // 没有结婚
            !this.isMarried
              ? // 就过滤掉非直系亲属
                this.enums?.contactRelation?.filter((e) => {
                  // 子-2女-3、孙-4、父母-5、祖父母-6
                  return ["2", "3", "5"].includes(e.value);
                })
              : this.enums?.contactRelation
        }
      ];
    },
    contacts2Fields() {
      return [
        {
          type: "text",
          label: "联系人姓名",
          required: true,
          key: "contactName",
          validator: (v, pre) => {
            const reg = /^(?:[\u4e00-\u9fa5·]{2,20})$/;
            if (v && !reg.test(v)) throw pre + "请输入正确的姓名";
            else return true;
          }
        },
        {
          type: "number",
          label: "联系人电话",
          required: true,
          key: "contactPhone",
          blur: () => {
            const contactPhone1 = this.contacts1Form.contactPhone;
            const contactPhone2 = this.contacts2Form.contactPhone;
            if (contactPhone1 == contactPhone2) {
              this.$errMsg("联系人2与联系人1电话号码不能相同！");
            } else {
              this.$toast.clear();
            }
          },
          validator: (v, pre) => {
            const contactPhone1 = this.contacts1Form.contactPhone;
            const contactPhone2 = this.contacts2Form.contactPhone;
            const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if (contactPhone1 == contactPhone2)
              throw "联系人2与联系人1电话号码不能相同！";
            else if (v && !reg.test(v)) throw pre + "请输入正确的手机号";
            else return true;
          }
        },
        {
          type: "select",
          label: "联系人关系",
          required: true,
          key: "contactRelation",
          enums: this.enums?.contactRelation || []
        }
      ];
    }
  },
  watch: {},
  mounted() {
    this.init();
    this.getAllEnums();
    window.agilityAutoFill = this.agilityAutoFill;
  },
  methods: {
    ...mapGetters(["getUserOrderInfo"]),
    init() {
      const data = this.getUserOrderInfo();
      this.bizNo = data.bizNo || "";
      this.prePlatOrderNo = data.prePlatOrderNo || "";
      this.getPersonalInfo();
    },
    async getPersonalInfo() {
      try {
        const { data } = await getPersonalInfo(this.bizNo);
        this.$set(this, "form", data || {});

        const { onlineCustomerContactPersonResVOList } = data || {};
        const contacts1 = onlineCustomerContactPersonResVOList
          ? onlineCustomerContactPersonResVOList[0]
          : null;
        if (contacts1) this.$set(this, "contacts1Form", contacts1);
        const contacts2 = onlineCustomerContactPersonResVOList
          ? onlineCustomerContactPersonResVOList[1]
          : null;
        if (contacts2) this.$set(this, "contacts2Form", contacts2);

        this.$set(this.form, "pcrcode", data?.regionCode || "");
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async getAllEnums() {
      try {
        const [d1, d2, d3, d4, d5, d6] = await Promise.all([
          getSomeEnums("education"),
          getSomeEnums("educationDegree"),
          getSomeEnums("maritalStatus"),
          getSomeEnums("resideStatus"),
          getSomeEnums("contactRelation"),
          getSomeEnums("resideYears")
        ]);

        this.$set(this.enums, "education", d1);
        this.$set(this.enums, "educationDegree", d2);
        this.$set(this.enums, "maritalStatus", d3);
        this.$set(this.enums, "resideStatus", d4);
        this.$set(this.enums, "contactRelation", d5);
        this.$set(this.enums, "resideYears", d6);
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async nextFn() {
      try {
        const infodom = this.$refs["form-personal"];
        const c1dom = this.$refs["form-contacts1"];
        const c2dom = this.$refs["form-contacts2"];
        if (!infodom || !c1dom || !c2dom) throw "页面渲染错误";

        await infodom.validate();
        await c1dom.validate();
        await c2dom.validate();

        const onlineCustomerContactPersonReqVOList = [
          this.contacts1Form,
          this.contacts2Form
        ];

        const params = {
          bizNo: this.bizNo,
          ...this.form,
          onlineCustomerContactPersonReqVOList
        };
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          duration: 0
        });
        await createPersonalInfo(params);

        infodom.clearCacheFormData();
        c1dom.clearCacheFormData();
        c2dom.clearCacheFormData();

        this.$toast.success("保存成功");
        this.$router.push("/works-info");
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async uploadUseInput() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.click();

      return new Promise((resp) => {
        input.onchange = async () => {
          this.$toast.loading({
            message: "图片上传中...",
            forbidClick: true,
            duration: 0
          });
          let file = input.files[0];
          let name = file.name;
          if (!isImage(name)) return this.$errMsg("请选择JPG格式的图片文件");
          if (!isJPG(name)) {
            file = await imageToJPG(file);
          }
          const { ossAccessUrl } = await uploadFile(file);
          return resp(ossAccessUrl);
        };
      });
    },

    // 配偶身份证识别
    async openIdcarOcr() {
      try {
        const ossAccessUrl = await this.uploadUseInput();
        this.$toast.loading({
          message: "图片识别中...",
          forbidClick: true,
          duration: 0
        });
        const { data } = await ocrIdentify({
          frontImageUrl: ossAccessUrl
        });
        this.$set(this.form, "nation", data.nation || "");
        this.$set(this.form, "address", data.address || "");
        this.$set(this.form, "idCardFrontUrl", ossAccessUrl || "");
        this.$set(this.form, "spouseName", data.name || "");
        this.$set(this.form, "spouseCertNo", data.idCardNo || "");

        this.$set(this.contacts1Form, "contactName", data.name);
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    setContacts1Name() {
      this.$set(this.contacts1Form, "contactName", this.form.spouseName);
    },
    // 开发快速调试
    agilityAutoFill() {
      let isdev = process.env.NODE_ENV === "development";
      if (isdev) {
        setFormData(this, "form", "apply_form_data_personal_form");
        setFormData(
          this,
          "contacts1Form",
          "apply_form_data_personal_con1_form"
        );
        setFormData(
          this,
          "contacts2Form",
          "apply_form_data_personal_con2_form"
        );
        this.$forceUpdate();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./input-style.scss";
.personal-info {
  .tit {
    display: flex;
    height: 88px;
    border-bottom: 1px solid #eee;
    & > * {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .arrow {
      flex: 1;
    }
    .item {
      color: #666;
      width: 45%;
      font-size: 32px;
      font-weight: bold;
    }
  }
  .btns {
    .van-button {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
